<template>
    <div>
        <section class="site-section pb-0" id="section-contact">
            <div class="container pb-0">
                <div class="row">
                    <div class="col-md-12 pb-0">
                        <div class="section-heading text-center">
                            <h2 class="strong">Kindly feel free to connect</h2>
                        </div>
                    </div>

                    <!-- <div class="col-md-7 mb-5 mb-md-0">
                        <form class="site-form">
                            <h3 class="mb-5 text-center">Get In Touch</h3>
                            <div class="form-group">
                                <input type="text" class="form-control px-3 py-4" v-model="CName" placeholder="Your Name">
                            </div>
                            <div class="form-group">
                                <input type="email" class="form-control px-3 py-4" v-model="CEmail" placeholder="Your Email">
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control px-3 py-4" v-model="CPhone" placeholder="Mobile number (optional)">
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control px-3 py-4" v-model="CSub" placeholder="Subject">
                            </div>
                            <div class="form-group mb-5">
                                <textarea class="form-control px-3 py-4" cols="30" rows="10" v-model="CMsg" placeholder="Write a Message" name="Message"></textarea>
                            </div>
                            <div class="form-group">
                                <center><input type="submit" class="btn btn-yellow  px-4 py-3" value="Send Message" @click.prevent="submitForm()"></center>
                            </div>
                        </form>
                    </div> -->
                    <div class="col-md-12 pt-0">
                        
                        <ul class="site-contact-details text-center">
                            <li>
                                <span class="text-uppercase" style="color: #FFFFFF; font-size: 20px">Email</span>
                                <a href="mailto:sohammayurdave@gmail.com" style="text-decoration: none"><span style="color: #FFFFFF; font-weight: 300;letter-spacing: 2px; font-size: 14px">sohammayurdave@gmail.com</span></a>
                            </li>
                            <br>
                            <li>
                                <span class="text-uppercase" style="color: #FFFFFF; font-size: 20px">Other Platforms</span>
                                <div class="site-footer pt-1">
                                    <div class="container">
                                        <div class="row">
                                            <div class="col-md-12 text-center">
                                                <p>
                                                    <span class="px-1"><a href="https://www.linkedin.com/in/sohamdave08/" target="_blank" class="social-item"><span class="icons"><i class="fab fa-linkedin-in"></i></span></a></span>
                                                    <span class="px-1"><a href="https://github.com/SohamDave08" target="_blank" class="social-item"><span class="icons"><i class="fab fa-github"></i></span></a></span>
                                                    <span class="px-1"><a href="https://medium.com/@SohamDave08" target="_blank" class="social-item"><span class="icons"><i class="fab fa-medium-m"></i></span></a></span>
                                                    <span class="px-1"><a href="https://www.instagram.com/dave_soham/" target="_blank" class="social-item"><span class="icons"><i class="fab fa-instagram"></i></span></a></span>
                                                </p>
                                            </div>
                                            <div class="row mb-2" style="display: none;">
                                                <p class="col-12 text-center">
                                                    <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
                                                    Copyright &copy;  All rights reserved | This template is made with <i class="icon-heart text-danger" aria-hidden="true" ></i> by <a href="https://colorlib.com" target="_blank" class="text-primary">Colorlib</a>
                                                    <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "footer"
    }
</script>

<style scoped>
    .icons{
		color: #FFB20A;
	}
</style>